var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-footer",style:({..._vm.defaultBg.style})},[_c('div',{staticClass:"s-topic-bg-wrap"},[_c('SAnimateImage',{attrs:{"width":_vm.defaultBg.style.width,"height":_vm.defaultBg.style.height,"src":_vm.defaultBg.src,"mask":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }